import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/CZ';

export const statements: DeepPartial<StatementsConfig> = {
    signed: true,
    subAccountStatements: true,
    deliveryDefinitions: {
        enabled: true,
        productTypes: ['CURRENT', 'SAVING'],
        languages: ['cs', 'en'],
        showStatementLanguageCell: true,
        showFeesWarning: true,
        showLanguageField: true,
        showEmailSelect: true,
    },
    showEmailIDsDropdown: false,
    modes: {
        electronic: 'ONLY_ELECTRONIC',
        postal: 'PAPER',
    },
    tableColumns: {
        DEFAULT: ['NAME', 'DATE', 'PERIODICITY', 'LANGUAGE', 'DOWNLOAD'],
        CREDIT: ['NAME', 'DATE', 'PERIODICITY', 'LANGUAGE', 'DOWNLOAD'],
    },
    deliverySelectable: true,
    deliveryEditorVersion: 2,
    deliveryChange,
    forceNoEmail: true,
    addAccessTokenToDownloadBody: true,
};
